// extracted by mini-css-extract-plugin
export var dropdownIcon = "_r3-6";
export var imgContainer = "_r3-3";
export var menuIcon = "_r3-5";
export var pillWrapper = "_r3-2";
export var pillsContainer = "_r3-1";
export var subscriptionCard = "_r3-0";
export var subscriptionLogo = "_r3-4";